export const vitamineD = [
  {
    id: 'vd-1',
    rank: 1,
    emoji: '🌞',
    name: "Nature's Best Vitamine D3 5000IU",
    brand: "Nature's Best",
    category: 'Vitamine D3',
    price: 18.95,
    priceDisplay: '€18,95',
    pricePerDay: '€0,21',
    dosage: '5000 IU',
    servings: 90,
    form: 'Capsule',
    vegan: true,
    glutenFree: true,
    rating: 4.8,
    reviewCount: 312,
    score: 9.4,
    scores: { kwaliteit: 92, prijskwaliteit: 88, ingredienten: 95, veiligheid: 90 },
    isBest: true,
    accentColor: 'var(--orange-pale)',
    features: ['Gecertificeerde ingrediënten', 'Beste prijs/kwaliteit', 'Glutenvrij & vegan'],
    pros: ['Hoogste biologische beschikbaarheid', 'Beste prijs per portie', 'Gecertificeerde ingrediënten'],
    cons: ['Hoge dosis — niet voor iedereen'],
    ingredients: ['Cholecalciferol (D3)', 'Olijfolie', 'Gelatine capsule'],
    link: '#',
  },
  {
    id: 'vd-2',
    rank: 2,
    emoji: '💊',
    name: 'Vitakruid Vitamine D3 75mcg',
    brand: 'Vitakruid',
    category: 'Vitamine D3',
    price: 14.95,
    priceDisplay: '€14,95',
    pricePerDay: '€0,25',
    dosage: '3000 IU',
    servings: 60,
    form: 'Tablet',
    vegan: false,
    glutenFree: true,
    rating: 4.7,
    reviewCount: 198,
    score: 8.9,
    scores: { kwaliteit: 87, prijskwaliteit: 85, ingredienten: 88, veiligheid: 91 },
    isBest: false,
    accentColor: '#E8F5EC',
    features: ['Made in Belgium', 'Betrouwbaar merk', 'Goed gedoseerd'],
    pros: ['Made in Belgium', 'Betrouwbaar merk', 'Goed gedoseerd'],
    cons: ['Bevat gelatine (niet vegan)', 'Minder porties per pot'],
    ingredients: ['Cholecalciferol', 'Rijstmeel', 'Gelatine capsule'],
    link: '#',
  },
  {
    id: 'vd-3',
    rank: 3,
    emoji: '🌿',
    name: 'Garden of Life Vitamine D3 Vegan',
    brand: 'Garden of Life',
    category: 'Vitamine D3',
    price: 24.99,
    priceDisplay: '€24,99',
    pricePerDay: '€0,28',
    dosage: '2000 IU',
    servings: 90,
    form: 'Capsule',
    vegan: true,
    glutenFree: true,
    rating: 4.6,
    reviewCount: 145,
    score: 8.6,
    scores: { kwaliteit: 88, prijskwaliteit: 79, ingredienten: 96, veiligheid: 93 },
    isBest: false,
    accentColor: '#EDF2FB',
    features: ['100% plantaardig', 'Bio-gecertificeerd', 'Uit korstmos (lichen)'],
    pros: ['100% plantaardig', 'Bio-gecertificeerd', 'Uit korstmos (lichen)'],
    cons: ['Lagere dosering', 'Hogere prijs'],
    ingredients: ['Lichen-extract (D3)', 'Zonnebloemolie', 'HPMC capsule'],
    link: '#',
  },
  {
    id: 'vd-4',
    rank: 4,
    emoji: '🔆',
    name: 'Solgar Vitamine D3 1000IU',
    brand: 'Solgar',
    category: 'Vitamine D3',
    price: 12.50,
    priceDisplay: '€12,50',
    pricePerDay: '€0,13',
    dosage: '1000 IU',
    servings: 100,
    form: 'Softgel',
    vegan: false,
    glutenFree: true,
    rating: 4.5,
    reviewCount: 224,
    score: 8.2,
    scores: { kwaliteit: 84, prijskwaliteit: 92, ingredienten: 83, veiligheid: 90 },
    isBest: false,
    accentColor: 'var(--orange-pale)',
    features: ['Goedkoopste per dag', 'Geschikt als onderhoud', 'Vertrouwd merk'],
    pros: ['Goedkoopste per dag', 'Geschikt als onderhoud', 'Vertrouwd merk'],
    cons: ['Lage dosis bij tekort', 'Niet vegan'],
    ingredients: ['Cholecalciferol', 'Olijfolie', 'Gelatine softgel'],
    link: '#',
  },
];

export const magnesium = [
  {
    id: 'mg-1',
    rank: 1,
    emoji: '🪨',
    name: 'Vitakruid Magnesium Malaat',
    brand: 'Vitakruid',
    category: 'Magnesium Malaat',
    price: 21.50,
    priceDisplay: '€21,50',
    dosage: '200 mg per tablet',
    servings: 120,
    rating: 4.7,
    reviewCount: 198,
    isBest: true,
    accentColor: '#E8F5EC',
    features: ['Snelle opname', 'Ondersteunt spieren & slaap', 'Made in Belgium'],
    pros: ['Snelle opname', 'Ondersteunt spieren & slaap', 'Made in Belgium'],
    cons: ['Iets duurder per portie'],
    ingredients: ['Magnesiummalaat', 'Rijstmeel', 'HPMC capsule'],
    scores: { kwaliteit: 89, prijskwaliteit: 84, ingredienten: 91, veiligheid: 93 },
    link: '#',
  },
  {
    id: 'mg-2',
    rank: 2,
    emoji: '💊',
    name: 'Pure Encapsulations Mg Bisglycinaat',
    brand: 'Pure Encapsulations',
    category: 'Magnesium Bisglycinaat',
    price: 29.95,
    priceDisplay: '€29,95',
    dosage: '120 mg per capsule',
    servings: 90,
    rating: 4.8,
    reviewCount: 156,
    isBest: false,
    accentColor: '#EDF2FB',
    features: ['Beste tolerantie', 'Geen laxerend effect', 'Ultra pure kwaliteit'],
    pros: ['Beste tolerantie', 'Geen laxerend effect', 'Ultra pure kwaliteit'],
    cons: ['Hogere prijs'],
    ingredients: ['Magnesiumbisglycinaat', 'Cellulose capsule'],
    scores: { kwaliteit: 93, prijskwaliteit: 78, ingredienten: 95, veiligheid: 94 },
    link: '#',
  },
  {
    id: 'mg-3',
    rank: 3,
    emoji: '🧂',
    name: 'Natural Calm Magnesium Citraat',
    brand: 'Natural Calm',
    category: 'Magnesium Citraat',
    price: 16.95,
    priceDisplay: '€16,95',
    dosage: '325 mg per portie',
    servings: 60,
    rating: 4.5,
    reviewCount: 211,
    isBest: false,
    accentColor: 'var(--orange-pale)',
    features: ['Poedervorm', 'Snel opneembaar', 'Rustgevend voor avond'],
    pros: ['Poedervorm', 'Snel opneembaar', 'Rustgevend voor avond'],
    cons: ['Suikersmaak niet voor iedereen'],
    ingredients: ['Magnesiumcitraat', 'Citroenzuur', 'Stevia'],
    scores: { kwaliteit: 84, prijskwaliteit: 88, ingredienten: 83, veiligheid: 89 },
    link: '#',
  },
  {
    id: 'mg-4',
    rank: 4,
    emoji: '🌊',
    name: 'Magtein Magnesium L-Threönaat',
    brand: 'Magtein',
    category: 'Magnesium L-Threönaat',
    price: 39.95,
    priceDisplay: '€39,95',
    dosage: '144 mg per capsule',
    servings: 90,
    rating: 4.6,
    reviewCount: 89,
    isBest: false,
    accentColor: '#E8F5EC',
    features: ['Passeert bloed-hersenbarrière', 'Geheugen & focus', 'Wetenschappelijk onderbouwd'],
    pros: ['Passeert bloed-hersenbarrière', 'Geheugen & focus', 'Wetenschappelijk onderbouwd'],
    cons: ['Duurste optie', 'Lagere elementaire magnesium'],
    ingredients: ['Magnesium L-threönaat', 'Cellulose capsule', 'Rijstmeel'],
    scores: { kwaliteit: 91, prijskwaliteit: 72, ingredienten: 94, veiligheid: 93 },
    link: '#',
  },
];

export const omega3 = [
  {
    id: 'o3-1',
    rank: 1,
    emoji: '🐟',
    name: 'Nordic Naturals Ultimate Omega',
    brand: 'Nordic Naturals',
    category: 'Omega-3 Visolie',
    price: 29.95,
    priceDisplay: '€29,95',
    dosage: '1280 mg per softgel',
    servings: 60,
    rating: 4.6,
    reviewCount: 145,
    isBest: true,
    accentColor: '#EDF2FB',
    features: ['Gecertificeerde visserij', 'Hoge EPA/DHA verhouding', 'Geen visgeur'],
    pros: ['Gecertificeerde visserij', 'Hoge EPA/DHA verhouding', 'Geen visgeur'],
    cons: ['Hogere prijs', 'Niet vegan'],
    ingredients: ['Visolie concentrate', 'EPA 650mg', 'DHA 450mg', 'Tocoferol'],
    scores: { kwaliteit: 91, prijskwaliteit: 80, ingredienten: 94, veiligheid: 92 },
    link: '#',
  },
  {
    id: 'o3-2',
    rank: 2,
    emoji: '🌿',
    name: 'Vegetology Opti3 Algenolie',
    brand: 'Vegetology',
    category: 'Omega-3 Vegan',
    price: 34.95,
    priceDisplay: '€34,95',
    dosage: '500 mg per softgel',
    servings: 60,
    rating: 4.7,
    reviewCount: 98,
    isBest: false,
    accentColor: '#E8F5EC',
    features: ['100% plantaardig', 'Geen visgeur', 'Duurzaam gewonnen'],
    pros: ['100% plantaardig', 'Geen visgeur', 'Duurzaam gewonnen'],
    cons: ['Lagere EPA verhouding', 'Hogere prijs'],
    ingredients: ['Algenolie', 'EPA 150mg', 'DHA 300mg', 'Zonnebloemolie'],
    scores: { kwaliteit: 90, prijskwaliteit: 78, ingredienten: 96, veiligheid: 94 },
    link: '#',
  },
  {
    id: 'o3-3',
    rank: 3,
    emoji: '💪',
    name: 'Momentous Omega-3',
    brand: 'Momentous',
    category: 'Omega-3 Sport',
    price: 44.95,
    priceDisplay: '€44,95',
    dosage: '2000 mg per portie',
    servings: 60,
    rating: 4.5,
    reviewCount: 67,
    isBest: false,
    accentColor: 'var(--orange-pale)',
    features: ['2000mg EPA+DHA', 'Herstel na training', 'NSF gecertificeerd'],
    pros: ['2000mg EPA+DHA', 'Herstel na training', 'NSF gecertificeerd'],
    cons: ['Duurste optie'],
    ingredients: ['Geconcentreerde visolie', 'EPA 1000mg', 'DHA 1000mg'],
    scores: { kwaliteit: 90, prijskwaliteit: 72, ingredienten: 93, veiligheid: 95 },
    link: '#',
  },
  {
    id: 'o3-4',
    rank: 4,
    emoji: '🫀',
    name: 'WHC UnoCardio 1000',
    brand: 'WHC',
    category: 'Omega-3 Hart',
    price: 38.50,
    priceDisplay: '€38,50',
    dosage: '1000 mg per softgel',
    servings: 60,
    rating: 4.8,
    reviewCount: 203,
    isBest: false,
    accentColor: '#EDF2FB',
    features: ['#1 in puurheidstest', 'Hart & bloedvaten', 'Belgisch merk'],
    pros: ['#1 in puurheidstest', 'Hart & bloedvaten', 'Belgisch merk'],
    cons: ['Hogere prijs'],
    ingredients: ['Visolie', 'EPA 500mg', 'DHA 380mg', 'Vitamine D3'],
    scores: { kwaliteit: 93, prijskwaliteit: 76, ingredienten: 95, veiligheid: 94 },
    link: '#',
  },
];

export const vitamines = [
  vitamineD[0],
  {
    id: 'vb-1',
    rank: 2,
    emoji: '🅱️',
    name: 'Solgar Methylcobalamine B12',
    brand: 'Solgar',
    category: 'Vitamine B12',
    price: 14.50,
    priceDisplay: '€14,50',
    dosage: '1000 mcg per tablet',
    servings: 60,
    rating: 4.7,
    reviewCount: 224,
    isBest: false,
    accentColor: '#EDF2FB',
    features: ['Actieve vorm methylcobalamine', 'Energie & zenuwstelsel', 'Vegan'],
    pros: ['Actieve vorm methylcobalamine', 'Energie & zenuwstelsel', 'Vegan'],
    cons: ['Smaak niet voor iedereen'],
    ingredients: ['Methylcobalamine', 'Mannitol', 'Aardbeiensmaak'],
    scores: { kwaliteit: 88, prijskwaliteit: 90, ingredienten: 89, veiligheid: 95 },
    link: '#',
  },
  {
    id: 'vc-1',
    rank: 3,
    emoji: '🍊',
    name: 'NOW Foods Vitamine C-1000',
    brand: 'NOW Foods',
    category: 'Vitamine C',
    price: 12.95,
    priceDisplay: '€12,95',
    dosage: '1000 mg per tablet',
    servings: 100,
    rating: 4.6,
    reviewCount: 187,
    isBest: false,
    accentColor: '#FFF8ED',
    features: ['Beste prijs/portie', 'Met bioflavonoïden', 'Immuunsysteem'],
    pros: ['Beste prijs/portie', 'Met bioflavonoïden', 'Immuunsysteem'],
    cons: ['Grote tabletten'],
    ingredients: ['Ascorbinezuur', 'Bioflavonoïden 250mg', 'Cellulose'],
    scores: { kwaliteit: 85, prijskwaliteit: 95, ingredienten: 86, veiligheid: 92 },
    link: '#',
  },
  {
    id: 'vk-1',
    rank: 4,
    emoji: '🥚',
    name: 'Vitakruid K2 + D3',
    brand: 'Vitakruid',
    category: 'Vitamine K2',
    price: 22.95,
    priceDisplay: '€22,95',
    dosage: '75 mcg K2 per capsule',
    servings: 60,
    rating: 4.5,
    reviewCount: 143,
    isBest: false,
    accentColor: 'var(--orange-pale)',
    features: ['MK-7 meest actieve vorm', 'Ondersteunt botgezondheid', 'Gecombineerd met D3'],
    pros: ['MK-7 meest actieve vorm', 'Ondersteunt botgezondheid', 'Gecombineerd met D3'],
    cons: ['Lagere dosering K2'],
    ingredients: ['Menaquinon-7 (K2)', 'Cholecalciferol (D3)', 'Olijfolie'],
    scores: { kwaliteit: 86, prijskwaliteit: 82, ingredienten: 88, veiligheid: 91 },
    link: '#',
  },
];

export const products = [
  // BioProphyl (Awin)
  {
    id: 1, naam: "Vitamine D3 K2 Voordeelpakket", merk: "BioProphyl", categorie: "Vitamines", netwerk: "Awin",
    url: "https://www.awin1.com/cread.php?awinmid=22561&awinaffid=2844128&ued=https%3A%2F%2Fwww.bioprophyl.be%2Fvitamin-d3-k2-vorteilspaket.html",
    afbeelding: "/images/products/bioprophyl-d3-druppels.jpg",
    beschrijving: "2x Vitamine D3 druppels (1000 IE/druppel, olijfolie) + 1x K2 100mcg — samen voor botten & immuunsysteem",
    prijs: "€39,58", dosering: "2 druppels D3 + K2 per dag",
    voordelen: ["Bundel van D3 én K2 samen", "750 druppels per D3-fles (langdurige voorraad)", "D3 opgelost in olijfolie voor betere opname", "Glutenvrij, lactosevrij, vegetarisch"],
    nadelen: ["Hogere instapprijs als bundel", "Vereist nauwkeurig doseren met pipet"],
  },
  {
    id: 2, naam: "Vitamine D3 K2 Tabletten", merk: "BioProphyl", categorie: "Vitamines", netwerk: "Awin",
    url: "https://www.awin1.com/cread.php?awinmid=22561&awinaffid=2844128&ued=https%3A%2F%2Fwww.bioprophyl.be%2Fvitamin-d3-k2.html",
    afbeelding: "/images/products/bioprophyl-d3-k2.jpg",
    beschrijving: "120 tabletten (4 maanden) — 1000 IE D3 + 75mcg K2 (all-trans MK-7) + 12mg vitamine C per tablet",
    prijs: "€34,62", dosering: "1 tablet per dag, 120 tabletten (4 maanden)",
    voordelen: ["D3 + K2 + vitamine C in één tablet", "Bioactieve all-trans MK-7 (zonder soja)", "120 tabletten = 4 maanden voorraad", "Glutenvrij, lactosevrij, allergeenvrij, vegetarisch"],
    nadelen: ["Vaste dosering — niet aanpasbaar", "Maltodextrine als vulmiddel"],
  },
  {
    id: 3, naam: "Algenolie Vegan Omega-3", merk: "BioProphyl", categorie: "Omega-3", netwerk: "Awin",
    url: "https://www.awin1.com/cread.php?awinmid=22561&awinaffid=2844128&ued=https%3A%2F%2Fwww.bioprophyl.de%2Fnl%2Falgenolie-vegan-omega-3-rijk-aan-epa-en-dha-60-capsules",
    afbeelding: "/images/products/bioprophyl-algenolie.png",
    beschrijving: "524mg algenolie per capsule — 94mg EPA + 210mg DHA, 60 maagzuurresistente capsules",
    prijs: "€23,95", dosering: "1–2 capsules per dag",
    voordelen: ["100% plantaardig en vegan", "94mg EPA + 210mg DHA per capsule", "Maagzuurresistente capsule — geen visgeur", "Duurzame gesloten kweek van microalgen"],
    nadelen: ["Hogere prijs dan reguliere visolie", "Minder EPA dan sommige viskapsels"],
  },
  {
    id: 4, naam: "Krillolie Omega-3", merk: "BioProphyl", categorie: "Omega-3", netwerk: "Awin",
    url: "https://www.awin1.com/cread.php?awinmid=22561&awinaffid=2844128&ued=https%3A%2F%2Fwww.bioprophyl.de%2Fnl%2Fomega-3-epa-dha%2F",
    afbeelding: null,
    beschrijving: "590mg krillolie per capsule — 44,5mg EPA + 20,5mg DHA + 25mcg astaxanthine. 90 capsules, MSC-gecertificeerd.",
    prijs: "€23,73", dosering: "1–2 capsules per dag, 90 capsules",
    voordelen: ["Fosfolipidenvorm = hogere biobeschikbaarheid dan visolie", "Bevat astaxanthine (25mcg krachtig antioxidant)", "MSC-gecertificeerde duurzame Antarctische krill", "Bevat choline voor leverfunctie"],
    nadelen: ["Niet geschikt voor veganisten (dierlijk product)", "Lagere EPA/DHA mg dan geconcentreerde visolie"],
  },
  {
    id: 5, naam: "Co-enzym Q10 100 Plus", merk: "BioProphyl", categorie: "Energie", netwerk: "Awin",
    url: "https://www.awin1.com/cread.php?awinmid=22561&awinaffid=2844128&ued=https%3A%2F%2Fwww.bioprophyl.de%2Fnl%2F",
    afbeelding: "/images/products/bioprophyl-q10.png",
    beschrijving: "60 vegan capsules — 100mg Q10 (fermentatief) + 100mg magnesium + 15mg vitamine E per capsule",
    prijs: "€34,62", dosering: "1 capsule per dag, 60 capsules (2 maanden)",
    voordelen: ["100mg Q10 uit fermentatieve productie (hoogste zuiverheid)", "Synergie met magnesium & vitamine E", "Relevant bij statinegebruik (statines verlagen Q10)", "Geen kunstmatige vulstoffen, 100% vegan"],
    nadelen: ["Effect pas merkbaar na 4–8 weken gebruik", "Hogere prijs voor dagelijks gebruik"],
  },

  // Vital Nutrition (Daisycon)
  {
    id: 6, naam: "Multivitamine + 7 Mineralen", merk: "Vital Nutrition", categorie: "Vitamines", netwerk: "Daisycon",
    url: "https://bdt9.net/c/?si=18988&li=1816067&wi=419831&ws=supverg&dl=collections%2Fmultivitamine",
    afbeelding: "/images/products/vitalnutrition-multivitamine.png",
    beschrijving: "28 ingrediënten per portie — actieve vitamine vormen, organisch gebonden mineralen, vegan, lab-getest. 90 capsules = 45 dagen.",
    prijs: "€29,95", dosering: "2 capsules per dag, 90 capsules (45 dagen)",
    voordelen: ["28 actieve ingrediënten inclusief methylcobalamine (B12) en P-5-P (B6)", "Plantaardige vitamine D3 (vegan)", "Organisch gebonden mineralen (citraat & bisglycinaat)", "Vegan, allergeenvrij, lab-getest op zware metalen"],
    nadelen: ["Geen mega-doses voor therapeutisch gebruik", "90 caps gaan maar 45 dagen mee bij 2/dag"],
  },
  {
    id: 7, naam: "Whey Proteïne", merk: "Vital Nutrition", categorie: "Proteïne", netwerk: "Daisycon",
    url: "https://bdt9.net/c/?si=18988&li=1816067&wi=419831&ws=supverg&dl=collections%2Feiwitpoeder",
    afbeelding: "/images/products/vitalnutrition-whey.png",
    beschrijving: "82% eiwit, mix van concentraat, isolaat & hydrolisaat",
    prijs: "€39,95", dosering: "1 schep (30g) per dag",
    voordelen: ["82% eiwitgehalte (bovengemiddeld hoog)", "Drievoudige mix voor snelle + trage opname", "Snel opneembaar na training", "Meerdere smaken beschikbaar"],
    nadelen: ["Bevat lactose — niet voor lactose-intolerantie", "Niet geschikt voor veganisten"],
  },
  {
    id: 8, naam: "Nootropic 7-in-1", merk: "Vital Nutrition", categorie: "Hersenen", netwerk: "Daisycon",
    url: "https://bdt9.net/c/?si=18988&li=1816067&wi=419831&ws=supverg&dl=products%2Fnootropic",
    afbeelding: "/images/products/vitalnutrition-nootropic.png",
    beschrijving: "7-in-1 formule: guarana, bacopa, rhodiola, ginseng, L-theanine, N-acetyl L-tyrosine & B6. 60 capsules = 30 dagen.",
    prijs: "€24,95", dosering: "2 capsules per dag, 60 capsules (30 dagen)",
    voordelen: ["7 klinisch onderbouwde ingrediënten", "Guarana + L-theanine voor focus zonder crash", "Bacopa & Rhodiola voor geheugen & stressresistentie", "Vegan, glutenvrij, lab-getest"],
    nadelen: ["Bevat cafeïne via guarana — niet voor cafeïnesensitieve mensen", "Effect volledig merkbaar na 4–6 weken"],
  },
  {
    id: 9, naam: "Creatine Monohydraat", merk: "Vital Nutrition", categorie: "Sport", netwerk: "Daisycon",
    url: "https://bdt9.net/c/?si=18988&li=1816067&wi=419831&ws=supverg&dl=collections%2Fsportvoeding",
    afbeelding: "/images/products/vitalnutrition-creatine.png",
    beschrijving: "500g puur creatine monohydraat — ±100 porties van 5g, lab-getest, gemaakt in Nederland",
    prijs: "€19,95", dosering: "3–5g per dag (onderhoud) of 20g/dag laadfase (5–7 dagen)",
    voordelen: ["500g = ca. 100 porties — uitstekende prijs/portie", "Creatine monohydraat: bewezen effectiefste vorm", "Ondersteunt kracht, explosiviteit én herstel", "Puur poeder — geen toevoegingen"],
    nadelen: ["Tijdelijke waterretentie in spieren is normaal", "Voldoende water drinken vereist"],
  },

  // Holland & Barrett BE (Awin)
  {
    id: 10, naam: "Vitamine D3 25mcg — 120 tabletten", merk: "Holland & Barrett", categorie: "Vitamines", netwerk: "Awin",
    url: "https://www.awin1.com/cread.php?awinmid=22561&awinaffid=2844128&ued=https%3A%2F%2Fwww.hollandandbarrett.be%2Fshop%2Fvitamines-supplementen%2Fvitamines%2F",
    afbeelding: null,
    beschrijving: "120 tabletten — 25mcg (1000 IE) vitamine D3 per tablet. Ondersteunt botten, tanden en immuunsysteem.",
    prijs: "€19,99", dosering: "1 tablet per dag, 120 tabletten (4 maanden)",
    voordelen: ["Goede dosis van 1000 IE per tablet", "120 tabletten = 4 maanden voorraad", "Breed verkrijgbaar in Belgische winkels", "Vertrouwd merk met kwaliteitscontrole"],
    nadelen: ["Minder hoge dosis dan specialistische druppels", "Geen K2 inbegrepen"],
  },
  {
    id: 11, naam: "Omega-3 Visolie 1000mg — 200 capsules", merk: "Holland & Barrett", categorie: "Omega-3", netwerk: "Awin",
    url: "https://www.awin1.com/cread.php?awinmid=22561&awinaffid=2844128&ued=https%3A%2F%2Fwww.hollandandbarrett.be%2Fshop%2Fvitamines-supplementen%2F",
    afbeelding: null,
    beschrijving: "1000mg visolie per softgel — 200 capsules voor hart, hersenen en gewrichten",
    prijs: "€24,99", dosering: "1–2 softgels per dag, 200 capsules",
    voordelen: ["200 capsules — uitstekende prijs per portie", "1000mg visolie met EPA & DHA per capsule", "Breed verkrijgbaar in Belgische winkels", "Vertrouwd Holland & Barrett merk"],
    nadelen: ["Lagere EPA/DHA concentratie dan geconcentreerde premium visolie", "Mogelijke visgeur — neem in bij maaltijd"],
  },
  {
    id: 12, naam: "Ashwagandha KSM-66® 500mg — 60 capsules", merk: "Holland & Barrett", categorie: "Stress & Slaap", netwerk: "Awin",
    url: "https://www.awin1.com/cread.php?awinmid=22561&awinaffid=2844128&ued=https%3A%2F%2Fwww.hollandandbarrett.be%2Fshop%2Fvitamines-supplementen%2F",
    afbeelding: null,
    beschrijving: "500mg KSM-66® ashwagandha-extract per capsule — gestandaardiseerd en klinisch getest. 60 capsules.",
    prijs: "€29,99", dosering: "1 capsule per dag, 60 capsules (2 maanden)",
    voordelen: ["KSM-66® is de meest bestudeerde ashwagandha-extract", "Gestandaardiseerd voor consistente werking", "Ondersteunt stressvermindering & slaapkwaliteit", "60 capsules = 2 maanden voorraad"],
    nadelen: ["Effect verschilt per persoon, meestal na 4–8 weken", "Niet aanbevolen tijdens zwangerschap of borstvoeding"],
  },
  {
    id: 13, naam: "Collageen Poeder 500g", merk: "EXVital", categorie: "Huid & Haar", netwerk: "Daisycon",
    url: "https://glp8.net/c/?si=20887&li=1889501&wi=419831&ws=&dl=nahrungsergaenzungsmittel%2Fsport%2F332%2Fcollagen-pulver-500-gramm-bioaktives-kollagen-von-exvital",
    afbeelding: null,
    beschrijving: "500g bioactief collageenhydrolysaat — type 1, 2 & 3, 93g eiwit per 100g, 18 aminozuren. Smaakloos, lab-getest, Made in Germany.",
    prijs: "€23,95", dosering: "10–30g per dag in koffie, smoothie of water",
    voordelen: ["500g = 17–50 porties — uitstekende prijs/portie", "Type 1, 2 & 3 collageen in één product", "93g eiwit per 100g — zeer hoge concentratie", "Smaakloos & snel oplosbaar, zonder toevoegingen, lab-getest"],
    nadelen: ["Dierlijk product (rund) — niet voor veganisten", "Grotere hoeveelheid (10–30g/dag) vereist een schep of weegschaal"],
  },

  // Magnesium
  {
    id: 14, naam: "Tri-Magnesium Dicitrat", merk: "EXVital", categorie: "Magnesium", netwerk: "Daisycon",
    url: "https://glp8.net/c/?si=20887&li=1889501&wi=419831&ws=supverg&dl=magnesium-malat",
    afbeelding: null,
    beschrijving: "322mg elementair magnesium per 3 capsules — 180 vegan capsules (60 dagen). Citraatsvorm voor hoge biobeschikbaarheid. Made in Germany.",
    prijs: "€16,95", dosering: "3 capsules per dag, 180 capsules (60 dagen)",
    voordelen: ["Citraatsvorm = uitstekende biologische beschikbaarheid", "322mg elementair magnesium per dagdosis", "180 capsules = 60 dagen voorraad", "Vegan, geen magnesiumstearaat, geen kunstmatige toevoegingen"],
    nadelen: ["3 capsules per dag nodig (meer dan andere merken)", "Iets duurder dan magnesiumoxide"],
  },
  {
    id: 15, naam: "Magnesium Citraat 100mg — 90 tabletten", merk: "Holland & Barrett", categorie: "Magnesium", netwerk: "Awin",
    url: "https://www.awin1.com/cread.php?awinmid=22561&awinaffid=2844128&ued=https%3A%2F%2Fwww.hollandandbarrett.be%2Fshop%2Fvitamines-supplementen%2Fmineralen%2Fmagnesium%2F",
    afbeelding: null,
    beschrijving: "100mg magnesium citraat per tablet — 90 tabletten. Citraatsvorm voor goede opname.",
    prijs: "€14,99", dosering: "1–3 tabletten per dag, 90 tabletten",
    voordelen: ["Citraatsvorm = betere opname dan oxide", "Betaalbaar en breed verkrijgbaar in België", "90 tabletten — goede prijs/portie", "Makkelijk in te nemen tablet"],
    nadelen: ["Lagere dosering per tablet (100mg)", "Minder elementair magnesium dan malaat of bisglycinaat"],
  },
  {
    id: 16, naam: "Expert Magnesium Bisglycinaat 150mg — 180 tabletten", merk: "Holland & Barrett", categorie: "Magnesium", netwerk: "Awin",
    url: "https://www.awin1.com/cread.php?awinmid=22561&awinaffid=2844128&ued=https%3A%2F%2Fwww.hollandandbarrett.be%2Fshop%2Fvitamines-supplementen%2Fmineralen%2Fmagnesium%2F",
    afbeelding: null,
    beschrijving: "150mg magnesium bisglycinaat per tablet — 180 tabletten (3–6 maanden). Beste tolerantie, geen laxerend effect.",
    prijs: "€24,99", dosering: "1–2 tabletten per dag, 180 tabletten",
    voordelen: ["Bisglycinaatsvorm = beste tolerantie voor gevoelige magen", "Geen laxerend effect zoals bij oxide", "180 tabletten = lang mee (3–6 maanden)", "Verkrijgbaar in H&B winkels in België"],
    nadelen: ["Hogere prijs dan oxide of citraat", "Minder elementair magnesium per tablet dan oxide"],
  },
  {
    id: 17, naam: "Magnesiumoxide 375mg — 90 tabletten", merk: "Holland & Barrett", categorie: "Magnesium", netwerk: "Awin",
    url: "https://www.awin1.com/cread.php?awinmid=22561&awinaffid=2844128&ued=https%3A%2F%2Fwww.hollandandbarrett.be%2Fshop%2Fvitamines-supplementen%2Fmineralen%2Fmagnesium%2F",
    afbeelding: null,
    beschrijving: "375mg magnesiumoxide per tablet — 100% ADH per tablet. 90 tabletten, goedkoopste instapoptie.",
    prijs: "€9,99", dosering: "1 tablet per dag, 90 tabletten (3 maanden)",
    voordelen: ["100% aanbevolen dagelijkse hoeveelheid in 1 tablet", "Goedkoopste magnesiumoptie", "90 tabletten = 3 maanden voorraad", "Breed verkrijgbaar in Belgische H&B-winkels"],
    nadelen: ["Magnesiumoxide = lagere biologische beschikbaarheid", "Kan laxerend effect geven bij hogere doses"],
  },

  // Mineralen
  {
    id: 18, naam: "Zink Bisglycinaat 25mg", merk: "EXVital", categorie: "Mineralen", netwerk: "Daisycon",
    url: "https://glp8.net/c/?si=20887&li=1889501&wi=419831&ws=supverg&dl=zink-bisglycinat",
    afbeelding: null,
    beschrijving: "25mg zink-bisglycinaat per tablet, 365 vegan tabletten = volledig jaarvoorraad. Made in Germany.",
    prijs: "€15,95", dosering: "1 tablet per dag (25mg)",
    voordelen: ["Chelaatvorm = maximale biologische beschikbaarheid", "Hoge dosering 25mg per capsule", "365 capsules — volledig jaarvoorraad", "Ondersteunt immuunsysteem, huid en haar"],
    nadelen: ["Niet gelijktijdig innemen met ijzer", "Hogere prijs dan zinkoxide"],
  },
  {
    id: 19, naam: "Gentle Iron 25mg", merk: "Solgar", categorie: "Mineralen", netwerk: "Awin",
    url: "https://www.awin1.com/cread.php?awinmid=22561&awinaffid=2844128&ued=https%3A%2F%2Fwww.hollandandbarrett.be%2Fshop%2Fvitamines-supplementen%2Fmineralen%2Fijzer%2F",
    afbeelding: null,
    beschrijving: "Gentle chelated ijzer, geen constipatie, geschikt voor vegetariërs, 90 capsules",
    prijs: "€15,95", dosering: "1 capsule per dag",
    voordelen: ["Geen constipatie of maagklachten", "Zachte chelated formule", "Geschikt voor vegetariërs", "Betrouwbaar merk met kwaliteitsgarantie"],
    nadelen: ["Lagere dosis (25mg) — niet voor ernstige tekorten", "Niet combineren met koffie of thee"],
  },
  {
    id: 20, naam: "Calcium + Magnesium", merk: "Holland & Barrett", categorie: "Mineralen", netwerk: "Awin",
    url: "https://www.awin1.com/cread.php?awinmid=22561&awinaffid=2844128&ued=https%3A%2F%2Fwww.hollandandbarrett.be%2Fshop%2Fvitamines-supplementen%2Fmineralen%2Fcalcium%2F",
    afbeelding: null,
    beschrijving: "Sterke combinatie voor botten en spieren, 250mg calcium + 125mg magnesium per tablet",
    prijs: "€13,95", dosering: "2 tabletten per dag",
    voordelen: ["Handig 2-in-1 combinatieproduct", "Ondersteunt botten én spieren", "Betaalbare prijs", "Ruim verkrijgbaar in België"],
    nadelen: ["Calcium en magnesium concurreren bij opname", "Neem op verschillende tijdstippen in voor optimaal effect"],
  },
  {
    id: 21, naam: "Selenium 200mcg", merk: "EXVital", categorie: "Mineralen", netwerk: "Daisycon",
    url: "https://glp8.net/c/?si=20887&li=1889501&wi=419831&ws=supverg&dl=selen",
    afbeelding: null,
    beschrijving: "Selenium als selenomethionine voor optimale opname, 365 capsules",
    prijs: "€14,95", dosering: "1 capsule per dag (200mcg)",
    voordelen: ["Selenomethioninvorm = beste biologische beschikbaarheid", "365 capsules — volledig jaarvoorraad", "Ondersteunt schildklier en immuunsysteem", "Bevorderlijk voor haar en nagels"],
    nadelen: ["Niet overdoseren (max. 400mcg/dag totaal)", "Effect pas zichtbaar na langdurig gebruik"],
  },

  // EXVital — Antioxidanten
  {
    id: 22, naam: "Curcuma + Piperine 90 capsules", merk: "EXVital", categorie: "Antioxidanten", netwerk: "Daisycon",
    url: "https://glp8.net/c/?si=20887&li=1889501&wi=419831&ws=&dl=nahrungsergaenzungsmittel%2Fgesundheit%2F227%2Fcurcuma-piperin-curcumin-hochdosiert-von-exvital-90-kapseln",
    afbeelding: null,
    beschrijving: "480mg curcumapoeder + 9,5mg piperine per capsule — hoge biobeschikbaarheid. 90 vegan capsules, biologisch, Made in Germany.",
    prijs: "€15,95", dosering: "1 capsule per dag, 90 capsules (3 maanden)",
    voordelen: ["Piperine verhoogt opname van curcumine tot 2000%", "480mg curcumapoeder per capsule — hooggedoseerd", "Biologisch, vrij van pesticiden, 100% vegan", "90 capsules = 3 maanden voorraad"],
    nadelen: ["Niet combineren met bloedverdunners zonder arts te raadplegen", "Effect pas merkbaar na weken gebruik"],
  },
];

export const allComparableProducts = [
  { id: 1, emoji: '🌞', name: "Nature's Best D3 5000IU", brand: "Nature's Best", category: 'Vitamine D3', price: 18.95, dosage: '5000 IU per capsule', servings: 90, rating: 4.8, reviews: 312, ingredients: ['Cholecalciferol (D3)', 'Olijfolie', 'Gelatine capsule'], pros: ['Hoge biologische beschikbaarheid', 'Glutenvrij & vegan', 'Gecertificeerde ingrediënten'], cons: ['Hoge dosis, niet voor iedereen'], score: { kwaliteit: 92, prijskwaliteit: 88, ingredienten: 95, veiligheid: 90 }, accentColor: 'var(--orange-pale)' },
  { id: 2, emoji: '🪨', name: 'Vitakruid Magnesium Malaat', brand: 'Vitakruid', category: 'Magnesium', price: 21.50, dosage: '200 mg per tablet', servings: 120, rating: 4.7, reviews: 198, ingredients: ['Magnesiummalaat', 'Rijstmeel', 'HPMC capsule'], pros: ['Snelle opname', 'Ondersteunt spieren & slaap', 'Made in Belgium'], cons: ['Iets duurder per portie'], score: { kwaliteit: 89, prijskwaliteit: 84, ingredienten: 91, veiligheid: 93 }, accentColor: '#E8F5EC' },
  { id: 3, emoji: '🐟', name: 'Nordic Naturals Ultimate Omega', brand: 'Nordic Naturals', category: 'Omega-3', price: 29.95, dosage: '1280 mg per softgel', servings: 60, rating: 4.6, reviews: 145, ingredients: ['Visolie concentrate', 'EPA 650mg', 'DHA 450mg', 'Tocoferol'], pros: ['Gecertificeerde visserij', 'Hoge EPA/DHA verhouding', 'Geen visgeur'], cons: ['Hogere prijs', 'Niet vegan'], score: { kwaliteit: 91, prijskwaliteit: 80, ingredienten: 94, veiligheid: 92 }, accentColor: '#EDF2FB' },
  { id: 4, emoji: '🅱️', name: 'Solgar Methylcobalamine B12', brand: 'Solgar', category: 'Vitamine B12', price: 14.50, dosage: '1000 mcg per tablet', servings: 60, rating: 4.7, reviews: 224, ingredients: ['Methylcobalamine', 'Mannitol', 'Aardbeiensmaak'], pros: ['Actieve vorm methylcobalamine', 'Energie & zenuwstelsel', 'Vegan'], cons: ['Smaak niet voor iedereen'], score: { kwaliteit: 88, prijskwaliteit: 90, ingredienten: 89, veiligheid: 95 }, accentColor: '#EDF2FB' },
  { id: 5, emoji: '🍊', name: 'NOW Foods Vitamine C-1000', brand: 'NOW Foods', category: 'Vitamine C', price: 12.95, dosage: '1000 mg per tablet', servings: 100, rating: 4.6, reviews: 187, ingredients: ['Ascorbinezuur', 'Bioflavonoïden 250mg', 'Cellulose'], pros: ['Beste prijs/portie', 'Met bioflavonoïden', 'Immuunsysteem'], cons: ['Grote tabletten'], score: { kwaliteit: 85, prijskwaliteit: 95, ingredienten: 86, veiligheid: 92 }, accentColor: '#FFF8ED' },
  { id: 6, emoji: '🌿', name: 'Vegetology Opti3 Algenolie', brand: 'Vegetology', category: 'Omega-3 Vegan', price: 34.95, dosage: '500 mg per softgel', servings: 60, rating: 4.7, reviews: 98, ingredients: ['Algenolie', 'EPA 150mg', 'DHA 300mg', 'Zonnebloemolie'], pros: ['100% plantaardig', 'Geen visgeur', 'Duurzaam gewonnen'], cons: ['Lagere EPA verhouding', 'Hogere prijs'], score: { kwaliteit: 90, prijskwaliteit: 78, ingredienten: 96, veiligheid: 94 }, accentColor: '#E8F5EC' },
];
